import { ChildProviderProps } from "@/types";
import { ProjectContextType, ProjetInfo } from "@/types/project";
import React, { useState, createContext, useContext } from "react";

// Create the context with an initial undefined value
export const ProjectContext = createContext<ProjectContextType | undefined>(
  undefined
);

export const ProjectProvider: React.FC<ChildProviderProps> = ({ children }) => {
  const [currentProject, setCurrentProject] = useState<ProjetInfo | null>(null);

  return (
    <ProjectContext.Provider value={{ currentProject, setCurrentProject }}>
      {children}
    </ProjectContext.Provider>
  );
};
export const useProject = (): ProjectContextType => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error("useProject must be used within a ProjectProvider");
  }
  return context;
};
